import EmailsComponent from '../../components/Emails/Emails';

function Emails() {
  return <EmailsComponent />;
}

export default Emails;
